export default class Mask extends PIXI.Graphics {
  constructor(bgAlpha, width, height, color, initialPoints) {
    super();

    this.alpha = bgAlpha;
    this.color = color;

    this.clear();

    this.beginFill(this.color, this.alpha);
    this.drawRect(initialPoints.x, initialPoints.y, width, height);
    this.endFill();
  }
}
